import api from "./client";

export async function listWorkCenterGroups({ search = null, includeInactive = false } = {}) {
  const data = await listWorkCenterGroupsPaged({ search, includeInactive });
  return data.items;
}

export async function listWorkCenterGroupsPaged({
  search = null,
  includeInactive = false,
  page,
  limit,
} = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", String(search));
  if (includeInactive) params.set("include_inactive", "1");
  if (page !== undefined && page !== null) params.set("page", String(page));
  if (limit !== undefined && limit !== null) params.set("limit", String(limit));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.get(`/work-center-groups${qs}`);
  return res.data.data;
}

export async function createWorkCenterGroup(payload) {
  const res = await api.post("/work-center-groups", payload);
  return res.data.data;
}

export async function updateWorkCenterGroup(id, payload) {
  const res = await api.put(`/work-center-groups/${id}`, payload);
  return res.data.data;
}

export async function deleteWorkCenterGroup(id) {
  const res = await api.delete(`/work-center-groups/${id}`);
  return res.data.data;
}
